"use client"

import type React from "react"

interface RejectionConfirmationModalProps {
  onClose: () => void
  onConfirm: () => void
  applicantName: string
  jobTitle: string
}

const RejectionConfirmationModal: React.FC<RejectionConfirmationModalProps> = ({ 
  onClose, 
  onConfirm, 
  applicantName,
  jobTitle 
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-md w-full mx-4 border">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-shrink-0 w-10 h-10 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
            <span className="text-red-600 dark:text-red-400 text-xl">⚠️</span>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Confirm Rejection</h3>
        </div>

        <div className="mb-6">
          <p className="text-gray-600 dark:text-gray-300 mb-3 leading-relaxed">
            You are about to reject the application for <strong className="text-gray-900 dark:text-white">{applicantName}</strong> for the position of <strong className="text-gray-900 dark:text-white">{jobTitle}</strong>.
          </p>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
            An automated rejection email will be sent to the applicant's email address.
          </p>
        </div>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors font-medium"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 transition-colors font-medium"
          >
            Confirm Rejection
          </button>
        </div>
      </div>
    </div>
  )
}

export default RejectionConfirmationModal

